import React, {
  useEffect,
  useState,
} from 'react';
import {
  TextField, Button, CardContent, CardHeader, FormControlLabel, Switch, Select, MenuItem, FormControl, InputLabel,
} from '@material-ui/core';
import GalleryField from 'components/GeneralCRUDComponent/FormFields/GalleryField/GalleryField';
import SearchFilterDropdown from 'components/SearchFilterComponent/SearchFilterDropdown';
import {
  WidgetInstance,
} from 'mobx-store/stores/customScreens/types';
import {
  Props,
} from './types';
import { NavigationOptions } from 'screens/addEditCustomScreen/components/navigationOptions';

const getWidgetParamsFields = (focusedWidgetData: WidgetInstance, handleChange: any) => {

  return (
    <>
      <NavigationOptions
        redirect={focusedWidgetData.params.redirect}
        entityId={focusedWidgetData.params.entityId}
        handleEntityIdChangeData={(value: string) => handleChange('redirect', value)}
        handleRedirectChangeData={(value: string) => handleChange('entityId', value)}
      />
    </>
  );
};


const TabWidgetCard: React.FC<Props> = (props: Props) => {
  useEffect(() => {
    props.handleChangeData('showTextImage', String(props.focusedWidgetData.params.showTextImage) === 'true');
  }, [])
  return (
    (
      <>
        <CardContent>
          <FormControlLabel
            control={(
              <Switch
                checked={String(props.focusedWidgetData.params.showTextImage) === 'true'}
                onChange={(event) => props.handleChangeData('showTextImage', event.target.checked)}
                name="showTextImage "
                color="primary"
              />
            )}
              label="show text image ?"
            />
            {
              String(props.focusedWidgetData.params.showTextImage) === 'true' ?
              <GalleryField
                errors=""
                touched=""
                filedType="GalleryField"
                onAddImage={(name, image) => {
                  props.handleChangeData('textImage', URL.createObjectURL(image));
                }}
                onRemoveImage={() => {
                  props.handleChangeData('textImage', '');
                }}
                name="widgetImage"
                value={props.focusedWidgetData.params.textImage ? [{
                  imageUrl: props.focusedWidgetData.params.textImage,
                }] : []}
                accept="image/*"
                size={200}
                label="Widget Image"
                isLimitToOneImage
              />
              :
              <TextField
                value={props.focusedWidgetData.params.subTitle || ''}
                onChange={(event) => props.handleChangeData('subTitle', event.target.value)}
                autoFocus
                margin="dense"
                id="widgetTitle"
                label="Widget Title"
                fullWidth
              />
            }
     
          <FormControlLabel
            control={
              <Switch
                checked={String(props.focusedWidgetData.params.isImageArrow) === 'true'}
                onChange={(event) => props.handleChangeData('isImageArrow', event.target.checked)}
                name="Is ImageArrow "
                color="primary"
              />
            }
            label="Is Image Arrow"
          />

          <GalleryField
            errors=""
            touched=""
            filedType="GalleryField"
            onAddImage={(name, image) => {
              props.handleChangeData('imageURL', URL.createObjectURL(image));
            }}
            onRemoveImage={() => {
              props.handleChangeData('imageURL', '');
            }}
            name="widgetImage"
            value={props.focusedWidgetData.params.imageURL ? [{
              imageUrl: props.focusedWidgetData.params.imageURL,
            }] : []}
            accept="image/*"
            size={200}
            label="Widget Image"
            isLimitToOneImage
          />
          {
            getWidgetParamsFields(props.focusedWidgetData, props.handleChangeData)
          }
        </CardContent>
      </>
    )
  );
};

export default TabWidgetCard;

